
import React, { createContext, Component } from "react";
import { withRouter } from "react-router-dom";

import * as Colyseus from "colyseus.js";

export const ClientColyseusContext = createContext();
let totalClients = 0;

class ClientColyseusContextProvider extends Component {
  state = {
    isAuth: false,
   //clientColyseus: new Colyseus.Client("ws://localhost:8080"),
     //clientColyseus: new Colyseus.Client(
     // process.env.WEBSOCKET_URL || "wss://syntaxmap-back.onrender.com"
   //), 
    clientColyseus: new Colyseus.Client('wss://' + "syntaxmap-back.onrender.com"),
    //clientColyseus: new Colyseus.Client("ws://" + "localhost:8080"),
    room: null,
    isMaster: false,
    isStarted: false,
    roomsList: [],
    roomClients: [],
    clientName:"",
    userCount:0,
    Clients:[],
  };

  componentDidMount() {
    console.log("clientColyseus context");
    console.log(this.state.clientColyseus);
    this.getAvailableRooms();
  }
  onInputChange(e) {
    e.preventDefault();

    this.setState({ currentText: e.target.value });
  }

  onSubmit(e) {
    e.preventDefault();
    this.chatRoom.send(this.state.currentText);
    this.setState({ currentText: "" });
  }
  updateUserCount = (count) => {
    this.setState({ userCount: count });
  };

  addListeners(room) {
    console.log("joined!");

    room.onMessage("connectedPlayers", (connectedPlayers) => {
      this.setState({ roomClients: connectedPlayers });
      console.log("Connected players:", connectedPlayers);
    });

    room.onMessage("*", (type, message) => {
      console.log("received message:", type, "=>", message);
    });


    room.onMessage("master", (type, message) => {
      this.setState({ isMaster: type.isMaster });
      console.log("received message:", type, "=>", message);
    });

    room.onMessage("yourSessionId", (message) => {
      this.setState({clientName : message.sessionId});
    })

    room.onMessage("*", (type, message) => {
      console.log("received message:", type, "=>", message);

      // Check for winner message from the server.
      if (type === "winner") {
        this.handleWinnerMessage(message); // Handle the winner message.
      }
    });
    room.onMessage("start", (type, message) => {
      this.setState({ isStarted: true });
      console.log("received message:", type, "=>", message);
    });
    room.onMessage("finish", (type, message) => {
      this.setState({ isStarted: false });
      console.log("received message:", type, "=>", message);
    });
    room.onLeave((client)=>{
      console.log("LEFT ROOM", arguments);
      //this.updateClientsList(room.clients);
      // A client left, update the roomClients array
    });

    room.onStateChange(function (state) {
      console.log("state change: ", state.toJSON());
      //this.updateClientsList(room.clients);
    });
  }

  /* updateClientsList = (clients) => {
    this.setState({ clients });
  };*/

  join = () => {
    this.state.clientColyseus
      .join(document.getElementById("room_name").value, { code: "one" })
      .then((r) => {
        this.setState({ room: r });
        this.addListeners(this.state.room);
        this.updateRoomClients(r.clients);
      })
      .catch((e) => {
        console.error(e.code, e.message);
      });
  };

  /*create = (roomType, roomName, roomPwd, course, course_id, nbQuestions) => {
    this.state.clientColyseus
      .create(roomType, {
        roomPwd: roomPwd,
        roomName: roomName,
        course: course,
        course_id: course_id,
        nbQuestions: nbQuestions,
      })
      .then((r) => {
        this.setState({ room: r });
        console.log("create room");
        console.log(nbQuestions);
        this.addListeners(this.state.room);
        this.props.history.push("/multiplayer/" + r.id,
        
        );
      });
  };*/

  // Inside the 'create' method in ClientColyseusContext
  create = (roomType, roomName, roomPwd, course, course_id, nbQuestions, TimePerQuestion) => {
this.state.clientColyseus.create(roomType, {
  roomPwd: roomPwd,
  roomName: roomName,
  course: course,
  course_id: course_id,
  nbQuestions: nbQuestions,
  TimePerQuestion:TimePerQuestion
})
.then((r) => {
  this.setState({ room: r });
  console.log("create room");
  console.log(nbQuestions);
  this.addListeners(this.state.room);
  // Update this line to include the state
  this.props.history.push({
    pathname: "/multiplayer/" + r.id,
    state: {
      roomType: roomType,
      roomName: roomName,
      roomPwd: roomPwd,
      course: course,
      course_id: course_id,
      nbQuestions: nbQuestions,
      TimePerQuestion: TimePerQuestion
    }
  });
});
  }


  joinOrCreate = () => {
    this.state.clientColyseus
      .joinOrCreate(document.getElementById("room_name").value, { code: "one" })
      .then((r) => {
        this.setState({ room: r });
        this.addListeners(this.state.room);
      });
  };

  joinById = (id) => {
    this.state.clientColyseus.joinById(id).then((r) => {
      this.setState({ room: r });
      this.addListeners(this.state.room);
      this.props.history.push("/multiplayer/" + r.id);
    });
  };

  getAvailableRooms = () => {
    this.state.clientColyseus
      .getAvailableRooms()
      .then((rooms) => {
        // Update the roomsList and Clients in the state
        this.setState({ roomsList: rooms });

        // Calculate the total number of clients in all available rooms
        let totalClients = 0;
        rooms.forEach((room) => {
          totalClients += room.clients;
        });

        // Update the userCount with the total number of clients
        this.setState({ Clients: totalClients }); 
      })
      .catch((e) => {
        console.error(e);
      });
  };

  
  reconnect = () => {
    this.state.clientColyseus
      .reconnect(this.state.room.id, this.state.room.sessionId)
      .then((r) => {
        this.setState({ room: r });
        this.addListeners(this.state.room);
      });
  };

  closeConnection = () => {
    this.state.room.connection.close();
  };
  
  handleWinnerMessage(message) {
    // Extract the winner information from the message.
    const winnerClientId = message.winner;

    // Find the winner's name or relevant information based on your game logic.
    // For example, if you have a list of players with IDs and names:
    const winnerPlayer = this.state.players.find(
      (player) => player.clientId === winnerClientId
    );
    const winnerName = winnerPlayer ? winnerPlayer.name : "Unknown";

    // Update the UI to display the winner's information.
    // For example, you can use React state to store the winner information.
    this.setState({ winner: winnerName });
  }
  render() {
    return (
      <ClientColyseusContext.Provider
        value={{
          ...this.state,
          createRoom: this.create,
          joinRoom: this.join,
          joinById: this.joinById,
          leaveRoom: this.closeConnection,
          getAvailableRooms: this.getAvailableRooms,
          roomClients: this.state.roomClients,
          clientName:this.state.clientName,
        }}
      >
        {this.props.children}
      </ClientColyseusContext.Provider>
    );
  }
}

export default withRouter(ClientColyseusContextProvider);